import { createApp } from 'vue'
import topStories from './top-stories.vue';
import {getPropsData} from '../../utils/helper-functions'

export default () => {
  document.querySelectorAll('top-stories').forEach((el) => {
    const propData = getPropsData(el.closest('section').nextElementSibling);
    createApp(topStories, {data:propData}).mount(el);
  })
}